import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            padding: '20px 30px 20px 30px',
        },
        title: {
            fontWeight: 'bold',
            wordBreak: 'break-word'
            //fontSize: '14px'
        }
        
    }
}

export { useStyles }